<template>
  <div class="wrapper-bar-2">
    <router-link
      :to="
        $i18nRoute({
          name: 'NewsDetail',
          params: { slug: item.url }
        })
      "
      v-for="(item, index) in list"
      :key="item.id"
      class="card"
      :class="`card-${index + 1}`"
    >
      <div class="card__img">
        <ImageContainer
          class="img"
          :src="item.image.medium"
          :thumb="item.image.thumbnail"
          :alt="item.title"
        />
      </div>
      <div class="card__descr">
        <div class="card__category">
          {{ item.sub_category.name }}
        </div>
        <div class="card__title limited-text">{{ item.title }}</div>
        <div class="data-news">
          <span class="day">{{ handleDate(item.pub_date) }},</span>
          <span class="time">{{ handleTime(item.pub_date) }}</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";

export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.wrapper-bar-2 {
  display: block;
  width: 100%;
}

.card {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  height: 65vw;
  position: relative;
  &__descr {
    width: 75%;
    margin: 1rem auto;
  }
  &__img {
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 30%;
      background: linear-gradient(
        179.58deg,
        rgba(18, 18, 18, 0) 0.36%,
        #121212 119.81%
      );
      z-index: -1;
    }
    .img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -2;
      border-radius: 0px;

      :deep() img {
        border-radius: 0px;
      }
    }
  }
}
.card {
  &__title {
    font-size: 20px !important;
    line-height: 27px !important;
  }
  &__category {
    font-weight: 600 !important;
    font-size: 14px !important;
    line-height: 19px !important;
    color: rgba(255, 255, 255, 0.7);
    text-transform: uppercase;
  }
}
@media screen and (max-width: 767px) {
  .card {
    &__title {
      font-size: 16px !important;
      line-height: 20px !important;
    }
    &__category {
      font-weight: 600 !important;
      font-size: 14px !important;
      line-height: 19px !important;
      color: rgba(255, 255, 255, 0.7);
      text-transform: uppercase;
    }
  }
}
</style>
